import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IGalleryApiResponse, IGalleryData } from '../../types/api/galleryApi';
import { getGalleryDataService } from '../../api/galleryApi';
import { IGalleryState } from '../../types/features/gallerySlice';
import { IFooterApiResponse, IFooterData } from '../../types/api/footerApi';
import { IFooterState } from '../../types/features/footerSlice';
import { getFooterDataService } from '../../api/footerApi';




export const getFooterData = createAsyncThunk<IFooterApiResponse>(
    'footer/getFooterData',
    async () => {
        const response = await getFooterDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const footerSlice = createSlice({
    name: 'footer',
    initialState: {
        footerLoader: false,
        footer:{} as IFooterData,
        status: false,
        msg: ''
    } as IFooterState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFooterData.pending, (state) => {
                state.footerLoader = true;
            })
            .addCase(getFooterData.fulfilled, (state, action: PayloadAction<IFooterApiResponse>) => {
                let data = action.payload.data;
                state.footer = data;
           
                state.msg = action.payload.message;
                state.status = true;
                state.footerLoader = false;
            })
           

    }
});

export default footerSlice.reducer;
